let isDOMContentLoaded = document.readyState === "complete";
const list = [];
export const DOMContentLoaded = (fn: () => void): void => {
	if (isDOMContentLoaded) {
		fn();
	} else {
		list.push(fn);
	}
};

document.addEventListener("DOMContentLoaded", () => {
	isDOMContentLoaded = true;

	list.forEach(
		(fn) =>
			new Promise<void>((resolve) => {
				fn();
				resolve();
			}),
	);
});
